module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/ants.88df19c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/phone/product/ants.jpg
// module id = MkER
// module chunks = 0